<footer class="footer-section">
  <div class="bg-white border-top p-2">
    <div class="row">
      <div class="col-lg-8 col-xl-9 col-md-6 text-center text-secondarytext-secondary text-md-left">
        <small>
          © {{currentYear}} Dubai Electricity and Water Authority PJSC. All Rights Reserved. The site is best viewed using IE edge and above, Mozilla Firefox, Safari and Chrome.</small>
      </div>
      <div class="col-lg-4 col-xl-3 col-md-6 text-center text-md-right text-secondary"><small>V5.2 | Server1</small></div>
    </div>
  </div>
</footer>
